import { InspectionStatus } from '../enums/inspection-status.enum';

/**
 * Extrai a chave do último status quando a API retorna vários separados por newline.
 */
export function getLastInspectionStatusKey(
  inspectionStatus: string | undefined | null
): InspectionStatus | '' {
  if (!inspectionStatus?.trim()) return '';
  const parts = inspectionStatus.split('\n').filter(part => part.trim());
  return parts.length > 0
    ? (parts[parts.length - 1].trim() as InspectionStatus)
    : (inspectionStatus.trim() as InspectionStatus);
}

function normalizeInspectionStatusToken(raw: string): string {
  return raw.trim().toLowerCase().replace(/_/g, '');
}

export function isInspectionTerminalStatus(
  status: string | undefined | null
): boolean {
  if (!status?.trim()) return false;
  const n = normalizeInspectionStatusToken(status);
  return (
    n === 'frustated' ||
    n === 'frustrated' ||
    n === 'canceled' ||
    n === 'cancelled'
  );
}
